module.exports = __webpack_public_path__ + "img/lfrm2.1d6e9500.jpg";